<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="file_009">There are a few types of felting, with wet felting being the most common form. Wool fibers are separated by hand and placed in layers into the desired pattern. With the addition of hot soapy water and agitation, the result is a felted fabric.</a></p><a id="file_009">
<p class="indent">Another popular felting method is to knit with wool yarn and then once the project is completed, the item is thrown into the washing machine with hot soapy water to agitate and felt. Needle felting does not involve wetting the fibers. You simply mold and shape wool with a barbed needle.</p>
<p class="indent">I was drawn to needle felting because I wanted more control working with wool and I wanted to make detailed figures and animals in three-dimensional forms. The felting needle was the key to my success. By using this tool, I was able to make all sorts of animals and characters with as much detail as I wanted. I especially enjoy needle felting because it doesn’t involve any measuring, weighing, counting, cutting, or other obstacles to creativity. It is a free-form and liberating craft experience!</p>
<p class="indent">In this book, I will share some needle-felting techniques that I have developed over the past few years. The goal is to encourage you to try needle felting and explore the many ways you can play with it. Let your imagination soar!</p>
<p class="indent">So without further ado, let’s get started!</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_009.vue?a63f8ef0